module.exports = __webpack_public_path__ + "deQOb6xYFjuKhT0iy/tandc_icon.svg";